// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"845":"2271da35","910":"bdd80737"}[chunkId] + ".chunk.js");